const ResumeApi = [
  {
    id: 1,
    category: "education",
    year: "Masai School (Jan 2022 - Oct 2022)",
    title: "Full Stack Web Development",
    desc: "MERN",
    rate: "89.20 %",
  },
  {
    id: 2,
    category: "education",
    year: "Dr. Babasaheb Ambedkar technologcal University (2017 - 2021)",
    title: "Bachelor of Technology",
    desc: "Mechanical Engineering",
    rate: "89.20 %",
  },
  {
    id: 3,
    category: "education",
    year: "S.F.L Highschool and Jr. College (2015 - 2017)",
    title: "HSC",
    desc: "",
    rate: "71.69 %",
  },
  {
    id: 4,
    category: "education",
    year: "S.F.L Highschool and Jr. College (2015 - 2017)",
    title: "SSC",
    desc: "",
    rate: "88.40 %",
  },
  {
    id: 4,
    category: "experience",
    year: "Sephora Clone (24 feb 2022 - 3 March 2022) ",
    title: "Diploma in Web Development",
    desc: "Contrary to popular belief. Ut tincidunt est ac dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet sem in, lobortis mauris hendrerit ante.",
    rate: "4.70/5 ",
  },
  {
    id: 5,
    category: "experience",
    year: "Job at Rainbow-Themes (2008 - 2016) ",
    title: "The Personal Portfolio Mystery",
    desc: "Generate Lorem Ipsum which looks. Ut tincidunt est ac dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet sem in, lobortis mauris hendrerit ante.",
    rate: "4.95/5 ",
  },
  {
    id: 6,
    category: "experience",
    year: "Works at Plugin Development (2016 - 2020) ",
    title: "Diploma in Computer Science",
    desc: "Maecenas finibus nec sem ut imperdiet. Ut tincidunt est ac dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet sem in, lobortis mauris hendrerit ante.",
    rate: "5.00/5 ",
  },
]

export default ResumeApi
